export enum IssueType {
    Loop,
    MissingReference,
    OccurenceMatrixOutOfDate,
    DashboardGuidDuplicate,
    InvalidFrequency,
    ValidationMissingReferenceGroup,
    TagNameDuplicate,
    OrphanGroup
}